<template>
    <div class="details">
        <Header :code="code">{{this.leadDetail.prenom}} {{this.leadDetail.nom}}</Header>
        <v-container>
            <v-row dense v-if='showContent'>
                <v-col cols="12" class="btn-wrapper">
                   <i class="mdi mdi-account-circle btn-icon" :class="slideValue == 0 ? 'active' : ''" @click="goToSlide(0)"></i> 
                   <i class="mdi mdi-car btn-icon" :class="slideValue == 1 ? 'active' : ''" @click="goToSlide(1)"></i>
                   <i class="mdi mdi-history btn-icon" :class="slideValue == 2 ? 'active' : ''" @click="goToSlide(2)"></i>
                </v-col>
                <v-col cols="12">
                    <v-carousel
                        height="auto"
                        hide-delimiters
                        light
                        :show-arrows="false"
                        ref='testSlide'
                        @change="changeValueSlide"
                    >
                        <v-carousel-item>
                            <Profil v-if="Object.keys(this.leadDetail).length > 0" :lead="this.leadDetail" :code="code" :key="id" />
                        </v-carousel-item>
                        <v-carousel-item>
                            <Vehicules v-if="Object.keys(this.leadDetail).length > 0" :lead="this.leadDetail" :code="code" :key="id"/>
                        </v-carousel-item>
                        <v-carousel-item>
                            <Historique v-if="Object.keys(this.leadDetail).length > 0" :lead="this.leadDetail" :code="code" :key="id"/>
                        </v-carousel-item>
                    </v-carousel>
                </v-col>
            </v-row>
        </v-container>
        <Footer03 :code="code" :lead="this.leadDetail"/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer03 from '@/components/Footer03'
import Profil from '@/components/Profil'
import Vehicules from '@/components/Vehicules'
import Historique from '@/components/Historique'
export default {
    name: 'Details',
    props: ['id', 'code'],
    components: {
        Header,
        Profil,
        Vehicules,
        Historique,
        Footer03
    },
    data() {
    return {
      leadDetail: {},
      slideValue: 0,
      arrows: false,
      showContent: true,
    }
  },
  computed: {

  },
  created() {
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
        if(Object.keys(this.$store.state.detailLead).length === 0){
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                    const lead = this.$store.state.leads.find(e => e.id == this.id);
                    this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                        this.$store.dispatch('setLoader', false)
                        this.leadDetail = this.$store.state.detailLead;
                    }) 
                })                
            })
        } else {
            this.leadDetail = this.$store.state.detailLead; 
        }
  },
  watch: {
      id: function(val){
          this.leadDetail = this.$store.state.detailLead;
      }
  },
  methods: {
      changeValueSlide: function(){
          if(this.$refs.testSlide){
                this.slideValue = this.$refs.testSlide.internalValue
          }
      },
      goToSlide(nb){
          this.slideValue = nb;
          this.$refs.testSlide.internalValue = nb;
      }
  },
}
</script>
<style lang="scss">
    .details {
        padding: 8vh 0;
        .btn-wrapper {
            display:flex;
            align-items: center;
            justify-content: center;
            .btn-icon {
                font-size:1.8em;
                margin: 0 10px;
                color: #081525;
                &.active {
                    color:#eb566b;
                }
            }
        }
        .v-window-item {
            min-height:100%;
        }
    }
</style>